fragment CompareContentSliderFragment on compareContentSlider_Entry {
  typeHandle
  heading
  body
  backgroundGray
  productList {
    ... on productListBlock_Entry {
      id
      primaryAttribute
      secondaryAttribute
      image {
        url
      }
      description
      cta {
        ...LinkFragment
      }
    }
  }
}
